import React from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';

const ProfileDetailTemplate = ({ children, title }) => {
  return (
    <>
     
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          my:2
        }}
      >
        <Box
          sx={{
            px: 2,
            py:1,
            backgroundColor:'#eee'
          }}
        >
          <Typography variant="subtitle1" component="div">
            {title}
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            mt: 1,
            px: 2,
          }}
        >
          {children}
        </Box>
      </Paper>
    </>
  );
};

export default ProfileDetailTemplate;
